import AdjuntosClass from "../datos/adjuntosClass";
import FotosClass from "../datos/fotosClass";
import ProgramacionClass from "../datos/programacionClass";
import InspeccionClass from "./inspeccionClass";

export default class InspeccionYProgramacion {
    public Inspeccion: InspeccionClass
    public Programacion: ProgramacionClass
    public Fotos: FotosClass[]
    public Adjuntos: AdjuntosClass[]
}